import { useEffect, useRef, useState } from 'react';

// Precise continent coordinate data for accurate mapping
// Using simplified polygon boundaries for each continent
const continentPolygons = {
  // North America - detailed coastline points
  northAmerica: [
    // Main continental US and Canada
    { lat: 49, lng: -125 }, { lat: 54, lng: -130 }, { lat: 60, lng: -140 }, { lat: 65, lng: -168 },
    { lat: 71, lng: -157 }, { lat: 71, lng: -95 }, { lat: 66, lng: -65 }, { lat: 60, lng: -64 },
    { lat: 52, lng: -55 }, { lat: 47, lng: -53 }, { lat: 44, lng: -66 }, { lat: 41, lng: -70 },
    { lat: 35, lng: -75 }, { lat: 30, lng: -81 }, { lat: 25, lng: -80 }, { lat: 25, lng: -97 },
    { lat: 28, lng: -97 }, { lat: 30, lng: -94 }, { lat: 29, lng: -90 }, { lat: 30, lng: -88 },
    { lat: 32, lng: -117 }, { lat: 34, lng: -120 }, { lat: 38, lng: -123 }, { lat: 42, lng: -124 },
    { lat: 46, lng: -124 }, { lat: 49, lng: -125 },
  ],
  // Mexico and Central America
  centralAmerica: [
    { lat: 32, lng: -117 }, { lat: 28, lng: -114 }, { lat: 23, lng: -110 }, { lat: 20, lng: -105 },
    { lat: 16, lng: -95 }, { lat: 14, lng: -92 }, { lat: 10, lng: -84 }, { lat: 8, lng: -80 },
    { lat: 9, lng: -79 }, { lat: 15, lng: -88 }, { lat: 18, lng: -88 }, { lat: 21, lng: -87 },
    { lat: 21, lng: -97 }, { lat: 25, lng: -97 }, { lat: 28, lng: -97 }, { lat: 32, lng: -117 },
  ],
  // South America
  southAmerica: [
    { lat: 12, lng: -72 }, { lat: 11, lng: -75 }, { lat: 4, lng: -77 }, { lat: -5, lng: -81 },
    { lat: -15, lng: -76 }, { lat: -18, lng: -70 }, { lat: -24, lng: -70 }, { lat: -27, lng: -71 },
    { lat: -33, lng: -72 }, { lat: -42, lng: -73 }, { lat: -46, lng: -75 }, { lat: -52, lng: -74 },
    { lat: -56, lng: -67 }, { lat: -55, lng: -65 }, { lat: -52, lng: -58 }, { lat: -42, lng: -63 },
    { lat: -35, lng: -57 }, { lat: -34, lng: -54 }, { lat: -32, lng: -52 }, { lat: -23, lng: -43 },
    { lat: -13, lng: -39 }, { lat: -7, lng: -35 }, { lat: -1, lng: -50 }, { lat: 5, lng: -52 },
    { lat: 8, lng: -60 }, { lat: 10, lng: -62 }, { lat: 11, lng: -68 }, { lat: 12, lng: -72 },
  ],
  // Europe
  europe: [
    { lat: 71, lng: 28 }, { lat: 70, lng: 30 }, { lat: 66, lng: 24 }, { lat: 60, lng: 5 },
    { lat: 58, lng: -5 }, { lat: 54, lng: -10 }, { lat: 51, lng: -10 }, { lat: 48, lng: -5 },
    { lat: 43, lng: -9 }, { lat: 36, lng: -6 }, { lat: 36, lng: -5 }, { lat: 38, lng: 0 },
    { lat: 41, lng: 2 }, { lat: 43, lng: 3 }, { lat: 43, lng: 8 }, { lat: 44, lng: 9 },
    { lat: 41, lng: 17 }, { lat: 40, lng: 20 }, { lat: 42, lng: 28 }, { lat: 46, lng: 30 },
    { lat: 54, lng: 20 }, { lat: 56, lng: 21 }, { lat: 60, lng: 28 }, { lat: 65, lng: 26 },
    { lat: 71, lng: 28 },
  ],
  // Africa
  africa: [
    { lat: 37, lng: 10 }, { lat: 37, lng: -1 }, { lat: 35, lng: -6 }, { lat: 28, lng: -13 },
    { lat: 21, lng: -17 }, { lat: 15, lng: -17 }, { lat: 12, lng: -16 }, { lat: 4, lng: -7 },
    { lat: 5, lng: 1 }, { lat: 4, lng: 10 }, { lat: -1, lng: 9 }, { lat: -6, lng: 12 },
    { lat: -17, lng: 12 }, { lat: -29, lng: 17 }, { lat: -34, lng: 18 }, { lat: -34, lng: 26 },
    { lat: -27, lng: 33 }, { lat: -15, lng: 40 }, { lat: -11, lng: 40 }, { lat: -1, lng: 42 },
    { lat: 5, lng: 49 }, { lat: 11, lng: 51 }, { lat: 12, lng: 44 }, { lat: 15, lng: 42 },
    { lat: 22, lng: 37 }, { lat: 28, lng: 34 }, { lat: 31, lng: 32 }, { lat: 32, lng: 25 },
    { lat: 32, lng: 12 }, { lat: 37, lng: 10 },
  ],
  // Asia (mainland)
  asia: [
    { lat: 77, lng: 100 }, { lat: 72, lng: 180 }, { lat: 66, lng: 180 }, { lat: 60, lng: 165 },
    { lat: 54, lng: 142 }, { lat: 45, lng: 142 }, { lat: 43, lng: 135 }, { lat: 35, lng: 129 },
    { lat: 32, lng: 130 }, { lat: 31, lng: 122 }, { lat: 24, lng: 119 }, { lat: 22, lng: 114 },
    { lat: 21, lng: 108 }, { lat: 10, lng: 109 }, { lat: 1, lng: 104 }, { lat: -8, lng: 114 },
    { lat: 8, lng: 77 }, { lat: 15, lng: 74 }, { lat: 24, lng: 68 }, { lat: 25, lng: 62 },
    { lat: 27, lng: 52 }, { lat: 30, lng: 48 }, { lat: 36, lng: 36 }, { lat: 41, lng: 29 },
    { lat: 42, lng: 28 }, { lat: 46, lng: 38 }, { lat: 47, lng: 40 }, { lat: 55, lng: 60 },
    { lat: 66, lng: 60 }, { lat: 77, lng: 70 }, { lat: 77, lng: 100 },
  ],
  // Australia
  australia: [
    { lat: -11, lng: 131 }, { lat: -14, lng: 127 }, { lat: -17, lng: 122 }, { lat: -22, lng: 114 },
    { lat: -26, lng: 113 }, { lat: -31, lng: 115 }, { lat: -35, lng: 117 }, { lat: -35, lng: 136 },
    { lat: -38, lng: 141 }, { lat: -39, lng: 146 }, { lat: -37, lng: 150 }, { lat: -32, lng: 152 },
    { lat: -28, lng: 153 }, { lat: -23, lng: 150 }, { lat: -19, lng: 146 }, { lat: -15, lng: 145 },
    { lat: -11, lng: 142 }, { lat: -11, lng: 131 },
  ],
  // Antarctica (visible portion)
  antarctica: [
    { lat: -65, lng: -60 }, { lat: -70, lng: -60 }, { lat: -75, lng: -30 }, { lat: -70, lng: 0 },
    { lat: -70, lng: 30 }, { lat: -68, lng: 50 }, { lat: -66, lng: 90 }, { lat: -66, lng: 120 },
    { lat: -67, lng: 140 }, { lat: -71, lng: 170 }, { lat: -78, lng: 165 }, { lat: -85, lng: 180 },
    { lat: -85, lng: -180 }, { lat: -75, lng: -130 }, { lat: -70, lng: -100 }, { lat: -65, lng: -60 },
  ],
};

// Generate precise continent points from polygon data
const generatePreciseContinentPoints = () => {
  const points = [];
  
  // Helper to generate points within a polygon
  const fillPolygon = (polygon, density, continent) => {
    if (polygon.length < 3) return;
    
    // Find bounding box
    let minLat = 90, maxLat = -90, minLng = 180, maxLng = -180;
    polygon.forEach(p => {
      minLat = Math.min(minLat, p.lat);
      maxLat = Math.max(maxLat, p.lat);
      minLng = Math.min(minLng, p.lng);
      maxLng = Math.max(maxLng, p.lng);
    });
    
    // Point-in-polygon test
    const isInPolygon = (lat, lng) => {
      let inside = false;
      for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
        const xi = polygon[i].lng, yi = polygon[i].lat;
        const xj = polygon[j].lng, yj = polygon[j].lat;
        if (((yi > lat) !== (yj > lat)) && (lng < (xj - xi) * (lat - yi) / (yj - yi) + xi)) {
          inside = !inside;
        }
      }
      return inside;
    };
    
    // Generate grid of points
    const latStep = 2.5 / density;
    const lngStep = 2.5 / density;
    
    for (let lat = minLat; lat <= maxLat; lat += latStep) {
      for (let lng = minLng; lng <= maxLng; lng += lngStep) {
        // Add some randomization to avoid grid appearance
        const jitterLat = lat + (Math.random() - 0.5) * latStep * 0.6;
        const jitterLng = lng + (Math.random() - 0.5) * lngStep * 0.6;
        
        if (isInPolygon(jitterLat, jitterLng)) {
          points.push({
            lat: jitterLat,
            lng: jitterLng,
            brightness: 0.5 + Math.random() * 0.5,
            continent
          });
        }
      }
    }
  };
  
  // Fill each continent with appropriate density
  fillPolygon(continentPolygons.northAmerica, 1.2, 'northAmerica');
  fillPolygon(continentPolygons.centralAmerica, 1.0, 'centralAmerica');
  fillPolygon(continentPolygons.southAmerica, 1.1, 'southAmerica');
  fillPolygon(continentPolygons.europe, 1.4, 'europe');
  fillPolygon(continentPolygons.africa, 1.2, 'africa');
  fillPolygon(continentPolygons.asia, 0.9, 'asia');
  fillPolygon(continentPolygons.australia, 1.3, 'australia');
  fillPolygon(continentPolygons.antarctica, 0.6, 'antarctica');
  
  return points;
};

// Generate multi-color orbiting nodes
const generateOrbitingNodes = (count) => {
  const nodes = [];
  const colors = [
    { r: 255, g: 255, b: 255 }, // White
    { r: 50, g: 255, b: 100 },  // Green
    { r: 255, g: 80, b: 80 },   // Red
    { r: 80, g: 180, b: 255 },  // Blue
  ];
  
  for (let i = 0; i < count; i++) {
    const orbitType = i % 8;
    let orbitRadius, orbitTilt;
    
    switch(orbitType) {
      case 0: orbitRadius = 0.06 + Math.random() * 0.06; orbitTilt = Math.random() * 0.2; break;
      case 1: orbitRadius = 0.10 + Math.random() * 0.08; orbitTilt = Math.PI * 0.1 + Math.random() * 0.2; break;
      case 2: orbitRadius = 0.15 + Math.random() * 0.1; orbitTilt = Math.PI * 0.25 + Math.random() * 0.2; break;
      case 3: orbitRadius = 0.20 + Math.random() * 0.1; orbitTilt = Math.PI * 0.35 + Math.random() * 0.15; break;
      case 4: orbitRadius = 0.25 + Math.random() * 0.1; orbitTilt = Math.PI * 0.4 + Math.random() * 0.15; break;
      case 5: orbitRadius = 0.30 + Math.random() * 0.1; orbitTilt = Math.PI * 0.45 + Math.random() * 0.1; break;
      case 6: orbitRadius = 0.35 + Math.random() * 0.1; orbitTilt = Math.PI * 0.3 + Math.random() * 0.2; break;
      default: orbitRadius = 0.12 + Math.random() * 0.25; orbitTilt = Math.random() * Math.PI * 0.5;
    }
    
    const color = colors[Math.floor(Math.random() * colors.length)];
    
    nodes.push({
      orbitRadius,
      orbitSpeed: 0.00012 + Math.random() * 0.00035,
      orbitTilt,
      orbitPhase: Math.random() * Math.PI * 2,
      orbitYaw: Math.random() * Math.PI * 2,
      size: 2 + Math.random() * 3,
      brightness: 0.6 + Math.random() * 0.4,
      pulseSpeed: 0.8 + Math.random() * 1.5,
      color,
    });
  }
  return nodes;
};

const Globe3D = () => {
  const canvasRef = useRef(null);
  const animationRef = useRef(null);
  const [reducedMotion, setReducedMotion] = useState(false);
  const mouseRef = useRef({ x: 0, y: 0 });
  const continentPointsRef = useRef(generatePreciseContinentPoints());
  const orbitingNodesRef = useRef(generateOrbitingNodes(80));
  
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    setReducedMotion(mediaQuery.matches);
    const handleChange = (e) => setReducedMotion(e.matches);
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);
  
  useEffect(() => {
    const handleMouseMove = (e) => {
      mouseRef.current = {
        x: (e.clientX / window.innerWidth - 0.5) * 2,
        y: (e.clientY / window.innerHeight - 0.5) * 2,
      };
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);
  
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    
    const ctx = canvas.getContext('2d');
    let rotation = 0;
    let tiltX = 0;
    let tiltY = 0;
    const continentPoints = continentPointsRef.current;
    const orbitingNodes = orbitingNodesRef.current;
    
    const resize = () => {
      const dpr = Math.min(window.devicePixelRatio, 2);
      canvas.width = canvas.offsetWidth * dpr;
      canvas.height = canvas.offsetHeight * dpr;
      ctx.scale(dpr, dpr);
    };
    
    resize();
    window.addEventListener('resize', resize);
    
    const latLngTo3D = (lat, lng, radius, rotY, tiltX, tiltY) => {
      const phi = (90 - lat) * (Math.PI / 180);
      const theta = (lng + rotY) * (Math.PI / 180);
      
      let x = radius * Math.sin(phi) * Math.cos(theta);
      let y = radius * Math.cos(phi);
      let z = radius * Math.sin(phi) * Math.sin(theta);
      
      const cosX = Math.cos(tiltX), sinX = Math.sin(tiltX);
      const cosY = Math.cos(tiltY), sinY = Math.sin(tiltY);
      
      const y1 = y * cosX - z * sinX;
      const z1 = y * sinX + z * cosX;
      const x1 = x * cosY + z1 * sinY;
      const z2 = -x * sinY + z1 * cosY;
      
      return { x: x1, y: y1, z: z2 };
    };
    
    const project = (point3D, centerX, centerY) => {
      const perspective = 800;
      const factor = perspective / (perspective + point3D.z);
      return {
        x: centerX + point3D.x * factor,
        y: centerY - point3D.y * factor,
        scale: factor,
        z: point3D.z
      };
    };
    
    const draw = (timestamp) => {
      const width = canvas.offsetWidth;
      const height = canvas.offsetHeight;
      const centerX = width / 2;
      const centerY = height / 2;
      const radius = Math.min(width, height) * 0.38;
      
      ctx.clearRect(0, 0, width, height);
      
      // Slow, smooth rotation
      const rotSpeed = reducedMotion ? 0.012 : 0.045;
      rotation += rotSpeed;
      
      // Mouse parallax
      const targetTiltX = mouseRef.current.y * 0.05;
      const targetTiltY = mouseRef.current.x * 0.07;
      tiltX += (targetTiltX - tiltX) * 0.01;
      tiltY += (targetTiltY - tiltY) * 0.01;
      
      const time = timestamp * 0.001;
      
      // Outer atmosphere glow
      const atmosGradient = ctx.createRadialGradient(centerX, centerY, radius * 0.85, centerX, centerY, radius * 1.5);
      atmosGradient.addColorStop(0, 'rgba(30, 100, 180, 0)');
      atmosGradient.addColorStop(0.3, 'rgba(30, 100, 180, 0.08)');
      atmosGradient.addColorStop(0.6, 'rgba(20, 80, 160, 0.04)');
      atmosGradient.addColorStop(1, 'rgba(20, 80, 160, 0)');
      ctx.fillStyle = atmosGradient;
      ctx.beginPath();
      ctx.arc(centerX, centerY, radius * 1.5, 0, Math.PI * 2);
      ctx.fill();
      
      // Globe base - darker ocean
      ctx.beginPath();
      ctx.arc(centerX, centerY, radius, 0, Math.PI * 2);
      const globeGradient = ctx.createRadialGradient(
        centerX - radius * 0.25, centerY - radius * 0.25, 0,
        centerX, centerY, radius
      );
      globeGradient.addColorStop(0, '#081830');
      globeGradient.addColorStop(0.5, '#051525');
      globeGradient.addColorStop(1, '#030a15');
      ctx.fillStyle = globeGradient;
      ctx.fill();
      
      // Subtle grid lines
      ctx.globalAlpha = 0.08;
      ctx.strokeStyle = '#2060a0';
      ctx.lineWidth = 0.5;
      
      for (let lat = -60; lat <= 60; lat += 30) {
        ctx.beginPath();
        let started = false;
        for (let lng = 0; lng <= 360; lng += 4) {
          const p3d = latLngTo3D(lat, lng, radius * 0.99, rotation, tiltX, tiltY);
          const p2d = project(p3d, centerX, centerY);
          if (p3d.z < radius * 0.1) {
            if (!started) { ctx.moveTo(p2d.x, p2d.y); started = true; }
            else ctx.lineTo(p2d.x, p2d.y);
          } else started = false;
        }
        ctx.stroke();
      }
      
      for (let lng = 0; lng < 360; lng += 30) {
        ctx.beginPath();
        let started = false;
        for (let lat = -90; lat <= 90; lat += 4) {
          const p3d = latLngTo3D(lat, lng, radius * 0.99, rotation, tiltX, tiltY);
          const p2d = project(p3d, centerX, centerY);
          if (p3d.z < radius * 0.1) {
            if (!started) { ctx.moveTo(p2d.x, p2d.y); started = true; }
            else ctx.lineTo(p2d.x, p2d.y);
          } else started = false;
        }
        ctx.stroke();
      }
      ctx.globalAlpha = 1;
      
      // Draw PRECISE continent points - smaller, finer dots
      continentPoints.forEach((point, i) => {
        const p3d = latLngTo3D(point.lat, point.lng, radius * 0.995, rotation, tiltX, tiltY);
        if (p3d.z > radius * 0.15) return;
        
        const p2d = project(p3d, centerX, centerY);
        const depthFade = Math.max(0.25, 1 - (p3d.z / radius) * 0.6);
        const pulse = 0.85 + 0.15 * Math.sin(time * 1.2 + i * 0.03);
        
        // Smaller, finer continent dots
        const size = 0.8 * p2d.scale * depthFade;
        const alpha = point.brightness * depthFade * pulse * 0.85;
        
        ctx.fillStyle = `rgba(140, 200, 255, ${alpha})`;
        ctx.beginPath();
        ctx.arc(p2d.x, p2d.y, size, 0, Math.PI * 2);
        ctx.fill();
      });
      
      // Draw MULTI-COLOR orbiting data points - larger, brighter
      const visibleNodes = [];
      orbitingNodes.forEach((node, i) => {
        const phase = node.orbitPhase + timestamp * node.orbitSpeed;
        const orbitR = radius * (1 + node.orbitRadius);
        
        const cosYaw = Math.cos(node.orbitYaw);
        const sinYaw = Math.sin(node.orbitYaw);
        
        let x = orbitR * Math.cos(phase);
        let y = orbitR * Math.sin(phase) * Math.sin(node.orbitTilt);
        let z = orbitR * Math.sin(phase) * Math.cos(node.orbitTilt);
        
        const x2 = x * cosYaw - z * sinYaw;
        const z2 = x * sinYaw + z * cosYaw;
        x = x2; z = z2;
        
        const cosX = Math.cos(tiltX), sinX = Math.sin(tiltX);
        const cosY = Math.cos(tiltY), sinY = Math.sin(tiltY);
        
        const y1 = y * cosX - z * sinX;
        const z1 = y * sinX + z * cosX;
        const x1 = x * cosY + z1 * sinY;
        const z3 = -x * sinY + z1 * cosY;
        
        const p2d = project({ x: x1, y: y1, z: z3 }, centerX, centerY);
        
        // Occasional connecting arcs between nearby nodes
        visibleNodes.forEach((other) => {
          const dx = p2d.x - other.x;
          const dy = p2d.y - other.y;
          const dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < 120 && dist > 40) {
            const opacity = (1 - dist / 120) * 0.2;
            ctx.strokeStyle = `rgba(180, 220, 255, ${opacity})`;
            ctx.lineWidth = 0.8;
            ctx.beginPath();
            ctx.moveTo(p2d.x, p2d.y);
            ctx.lineTo(other.x, other.y);
            ctx.stroke();
          }
        });
        
        visibleNodes.push({ x: p2d.x, y: p2d.y });
        
        const pulse = 0.5 + 0.5 * Math.sin(time * node.pulseSpeed + i);
        const { r, g, b } = node.color;
        
        // Larger, brighter orbiting points with glow
        const nodeGradient = ctx.createRadialGradient(p2d.x, p2d.y, 0, p2d.x, p2d.y, node.size * 5);
        nodeGradient.addColorStop(0, `rgba(${r}, ${g}, ${b}, ${node.brightness * pulse * 0.95})`);
        nodeGradient.addColorStop(0.35, `rgba(${r}, ${g}, ${b}, ${node.brightness * pulse * 0.4})`);
        nodeGradient.addColorStop(1, `rgba(${r}, ${g}, ${b}, 0)`);
        ctx.fillStyle = nodeGradient;
        ctx.beginPath();
        ctx.arc(p2d.x, p2d.y, node.size * 5, 0, Math.PI * 2);
        ctx.fill();
        
        // Bright core
        ctx.fillStyle = `rgba(${Math.min(255, r + 60)}, ${Math.min(255, g + 60)}, ${Math.min(255, b + 60)}, ${node.brightness * pulse})`;
        ctx.beginPath();
        ctx.arc(p2d.x, p2d.y, node.size * 1.3, 0, Math.PI * 2);
        ctx.fill();
      });
      
      // Inner rim highlight
      ctx.beginPath();
      ctx.arc(centerX, centerY, radius, 0, Math.PI * 2);
      const rimGradient = ctx.createRadialGradient(centerX, centerY, radius * 0.92, centerX, centerY, radius);
      rimGradient.addColorStop(0, 'rgba(60, 140, 220, 0)');
      rimGradient.addColorStop(1, 'rgba(60, 140, 220, 0.15)');
      ctx.fillStyle = rimGradient;
      ctx.fill();
      
      animationRef.current = requestAnimationFrame(draw);
    };
    
    animationRef.current = requestAnimationFrame(draw);
    
    return () => {
      window.removeEventListener('resize', resize);
      if (animationRef.current) cancelAnimationFrame(animationRef.current);
    };
  }, [reducedMotion]);
  
  return (
    <canvas
      ref={canvasRef}
      className="absolute inset-0 w-full h-full"
      data-testid="globe-canvas"
      style={{ background: 'transparent' }}
    />
  );
};

export default Globe3D;
